import thankYouImage from 'assets/messageSayingThankYou.svg';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { breakpoint } from 'app/theme/theme';
import { thankYouPage } from 'app/translations/dictionary/thankYouPage';
import { DialogWithImage } from 'pkg/components/DialogWithImage';
import { useTitle } from 'pkg/titleHooks/useTitle';

import { UpdaterEmailForm } from './UpdaterEmailForm';

const Title = styled.h1`
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 2.8rem;
  text-align: center;
  margin-bottom: 3rem;
  ${breakpoint.up.sm`
    font-size: 2.2rem;
    text-align: left;
    line-height: 3.5rem; 
  `}
  ${breakpoint.up.md`
    font-size: 3.5rem;
    text-align: left;
    line-height: 4.7rem;
    padding-right: 0.5rem;
    margin-bottom: 4.5rem;
  `}
`;

const DialogContent = styled.div`
  max-width: 40rem;
  margin-top: 2.5rem;
  ${breakpoint.up.sm`
    max-width: 100%;
    margin: 0 5rem 2.5rem 3rem;
  `}
`;

const Image = styled.img`
  width: 17.3rem;
  height: 14.3rem;
  margin-top: 0.5rem;
  ${breakpoint.up.sm`
    width: 27.2rem;
    height: 22.5rem;
    margin-top: 0;
    margin-left: 3rem;
  `}
  ${breakpoint.up.md`
    width: 37.1rem;
    height: 30.7rem;
  `}
`;

export const ThankYouPage = (): JSX.Element => {
  useTitle(thankYouPage.title);
  const history = useHistory();
  const serviceType =
    Object.entries(thankYouPage.serviceType).find(([key]) => history.location.pathname.includes(key))?.[1] ??
    thankYouPage.serviceType.translationquote;

  return (
    <DialogWithImage
      onClose={() => window.location.replace('/')}
      image={<Image src={thankYouImage} alt={thankYouPage.altImg} />}
    >
      <DialogContent>
        <Title>{`${thankYouPage.dialogTitle.thankYouForContact} ${serviceType} ${thankYouPage.dialogTitle.emailedShortly}`}</Title>
        <UpdaterEmailForm />
      </DialogContent>
    </DialogWithImage>
  );
};
